import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-salesreport',
  templateUrl: './salesreport.component.html',
  styleUrls: ['./salesreport.component.scss']
   // providers: [DatePipe] 
})
export class SalesreportComponent implements OnInit {

  To: string;
  From: string;
   public selectedStore: string = '';
     public stores: any[] = []; 
  Module_Row: any;
  public rows = [];
  public add: any = {};
  public addValidation: boolean = false;
public totalAmount: number = 0;
  constructor(public appservice: AppService,public datePipe: DatePipe) { 
    // this.appservice.get_S_Deal_Report();
   // this.appservice.get_SalesReport();
   
   this.From = this.datePipe.transform(new Date(), "yyyy-MM-dd")!;
  this.To = this.datePipe.transform(new Date(), "yyyy-MM-dd")!;
  }
  
//  Module_Name=[];
//   get_Module() {
//     this.appservice.getc("Api/Setting/get_ModuleName1").subscribe((res: any) => {
//       this.Module_Row = JSON.parse(res).record;   
//     });
//   }
public SummaryReport_Row = [];
get_SalesReport() {
    const storeValue = this.selectedStore === 'ALL' ? '' : this.selectedStore;
  this.appservice.get(`Api/transaction/get_SalesReport?From=${this.From}&To=${this.To}`)
    .subscribe((res: any) => {   
      if (res && res !== '') {
        const parsed = JSON.parse(res);
        this.SummaryReport_Row = parsed.record || [];

        // Calculate total amount
        this.totalAmount = this.SummaryReport_Row.reduce((sum, row) => {
          const total = parseFloat(row['Total']) || 0;
          return sum + total;
        }, 0);

        console.log("the records are ", this.SummaryReport_Row[0]);
        console.log("Total Amount:", this.totalAmount);
      }
      else {
        this.SummaryReport_Row = [];
        this.totalAmount = 0;
        alert("No Data Found");  
      }
    });
}
  // loadStores() {
  //   this.appservice.get('Api/transaction/get_stores')
  //     .subscribe({
  //       next: (res: any) => {
  //         try {
  //           const parsed = typeof res === 'string' ? JSON.parse(res) : res;
  //           const data = Array.isArray(parsed) ? parsed : parsed?.record || [];
  //           this.stores = data.map((x: any) => ({
  //             id: x.SM_iid,
  //             name: x.SM_storeName
  //           }));
  //         } catch (err) {
  //           console.error('Error parsing stores:', err);
  //           this.stores = [];
  //         }
  //       },
  //       error: (err) => {
  //         console.error('Error loading stores:', err);
  //         this.stores = [];
  //       }
  //     });
  // }

//   get_SalesReport() {
//   //this.isload = true;
//   this.appservice.get("Api/transaction/get_SalesReport?From=" + this.From + "&To=" + this.To)
//     .subscribe((res: any) => {   
//       //this.isload = false;
//       if(res!=""){
// this.SummaryReport_Row = JSON.parse(res).record;
//       console.log("the records are ",this.SummaryReport_Row[0]);
//       }
//       else{alert("No Data Found");  }
//     }); 
//     console.log("the records are 1",this.SummaryReport_Row[0]);
// }

//    public Summary_rows=[
//  { Field: 'Item Name', Name: 'Item Name', Align: '' },
 
//  { Field: 'Unit Rate', Name: 'Unit Price', Align: '' },
//  { Field: 'Barcode', Name: 'Barcode', Align: '' },
//  { Field: 'Phone No', Name: 'Customer Address', Align: '' },


//   ]; 
  
  ngOnInit(): void {
    //  this.loadStores();
  }
  Back() {
    this.appservice.back();
  }

  display() {
    debugger
    this.get_SalesReport();

  }
  export_excel()
  {
  //  this.appservice.Timesheet_Entry_Export =  this.appservice.get_fields_of('Customer_Details');

   //this.appservice.Excel_Data.Header=this.Summary_rows;
   this.appservice.Excel_Data.items=this.appservice.SummaryReport_Row;
   this.appservice.Excel_Data.Report_Name="SummaryReport";
   this.appservice.Excel_Data.FileName="SummaryReport";
   this.appservice.export_excel();
 
  }

}
